import {
  UPDATE_STORE_DATA_FIELD,
  GET_PAYMENT_STATUS,
  BIND_CARD,
} from '../constants/actionTypes';

const initialState = {
  currentStepIndex: 0,
  payment: {
    exponent: 2,
    amount: 0,
    currency: 643,
    isRegular: false,
    mutable: true,
    period: 0,
    maxAmount: 15000000,
  },
};

function setField(keys, obj, value) {
  if (keys.length > 1) {
    setField(keys.slice(1), obj[keys[0]], value);
  } else {
    obj[keys[0]] = value;
  }
}

export default function data(state = initialState, action) {
  switch (action.type) {
    case BIND_CARD:
      return {
        ...state,
        ...action.payload,
        txStarted: true,
      };

    case GET_PAYMENT_STATUS:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_STORE_DATA_FIELD:
      const { field, value } = action.payload;

      if (typeof field !== 'string') return state;

      const keysArr = field.split('.');
      const fKey = keysArr[0];
      const fKeyVal = state[fKey];
      const newState = { [fKey]: typeof fKeyVal === 'object' ? { ...fKeyVal } : fKeyVal };

      setField(keysArr, newState, value);

      return {
        ...state,
        ...newState,
      };

    default:
      return state;
  }
}
